import { PROCESS } from "@/data/site";
import { Reveal, MaskedLines } from "@/components/Motion";
import { SectionLabel } from "@/components/SectionLabel";

export const ProcessSteps = ({ index = "05" }) => (
  <section className="py-24 sm:py-32" aria-labelledby="process-heading" data-testid="process-section">
    <div className="shell">
      <div className="grid gap-8 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <SectionLabel index={index}>Our process</SectionLabel>
        </div>
        <div className="lg:col-span-7">
          <MaskedLines
            as="h2"
            className="font-display text-4xl font-extrabold tracking-[-0.04em] text-navy sm:text-5xl lg:text-6xl"
            lines={[{ content: "Three clear stages." }, { content: "One considered result.", className: "text-royal" }]}
          />
        </div>
      </div>
      <ol className="mt-16 border-t border-[var(--line)]">
        {PROCESS.map((step, i) => (
          <Reveal as="li" key={step.n} delay={i * 0.08} className="group relative border-b border-[var(--line)]">
            <div className="grid items-center gap-4 py-10 transition-[padding] duration-500 ease-expo md:grid-cols-12 md:py-14 md:hover:pl-6" data-testid={`process-step-${step.title.toLowerCase()}`}>
              <span className="text-outline font-display text-7xl font-extrabold leading-none tracking-[-0.06em] text-navy/40 transition-colors duration-500 group-hover:text-royal md:col-span-4 md:text-[9rem]">
                {step.n}
              </span>
              <h3 className="font-display text-3xl font-bold tracking-tight text-navy md:col-span-3 md:text-4xl">
                <span className="relative">
                  {step.title}
                  <span className="absolute -bottom-1 left-0 h-[3px] w-0 bg-lime transition-[width] duration-500 ease-expo group-hover:w-full" aria-hidden="true" />
                </span>
              </h3>
              <p className="max-w-md text-base leading-relaxed text-slatey md:col-span-5 md:text-lg">{step.text}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
